import { useEffect, useRef, useState } from "react";

export const BOTTOM_SHEET_ANIMATION_MS = 400;
export const DESKTOP_MODAL_ANIMATION_MS = 500;

type UseBottomSheetAnimationResult = {
  shouldRender: boolean;
  isClosing: boolean;
};

export const useBottomSheetAnimation = (
  isOpen: boolean,
  isMobile: boolean,
): UseBottomSheetAnimationResult => {
  const [shouldRender, setShouldRender] = useState<boolean>(isOpen);
  const [isClosing, setIsClosing] = useState<boolean>(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (isOpen) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setShouldRender(true);
      setIsClosing(false);
      return;
    }

    if (!shouldRender) return;

    const delayMs = isMobile ? BOTTOM_SHEET_ANIMATION_MS : DESKTOP_MODAL_ANIMATION_MS;
    setIsClosing(true);
    timeoutRef.current = setTimeout(() => {
      setShouldRender(false);
      setIsClosing(false);
      timeoutRef.current = null;
    }, delayMs);
  }, [isOpen, isMobile, shouldRender]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return { shouldRender, isClosing };
};
